import React, { Component } from 'react';

import SkyLight from 'react-skylight';

class ModalView360 extends Component {
    constructor(props){
        super(props);
    }

    show() {
        this.refs.view360.show();
    }

    render() {
        return (
            <SkyLight hideOnOverlayClicked={false} ref="view360"
                      dialogStyles={{
                          padding: 0, width: '85vw', height: '75vh', top: '50%', left: "50%", zIndex: 9999, background: "#efefef", transform: 'translate(-50%, -50%)', margin: 0,
                          borderRadius: "8px",
                      }}
                      titleStyle={{ display: 'none' }}
                      closeButtonStyle={{
                          color: '#eeeeee', backgroundColor: '#333', border: '2px solid #eee', borderRadius: '50%', width: '1.5em', height: '1.5em', textAlign: 'center', lineHeight: '1.3em',
                          top: '-1em', right: '-0.8em', fontSize: '16px', margin: 'auto', padding: '0px',
                      }}
            >
                <div className="inner-large-content" style={{ height: '100%' }}>
                    <iframe style={{ width: '100%', height: '100%', borderRadius: "8px" }} src={this.props.urlView360} height="100%" width="100%" frameBorder="0"></iframe>
                </div>
            </SkyLight>
        );
    }
}

export default ModalView360;
